import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {ref,onMounted,onBeforeUnmount,watch,defineAsyncComponent} from 'vue'
import {useRoute} from 'vue-router'
import store from '@/store'
import {orderRowDetailEvent,detailRow} from '@/utils/orderRowDetails'

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderRowDetailHost',
  setup(__props) {

const AllOrderDetailWindow=defineAsyncComponent(()=>import('./AllOrderDetailWindow.vue'))
const route=useRoute(),selected=ref<any>(null),rows=ref<any[]>([])
let sourceRows:any[]=[],sourcePath=''
function clear(){selected.value=null;rows.value=[];sourceRows=[];sourcePath=''}
function open(event:Event){const value=(event as CustomEvent).detail;if(selected.value || route.query.orderDetailEmbed==='1' || value?.path!==route.path)return;const order=detailRow(value.order,route.path);if(!order || !Array.isArray(value.rows) || !Array.isArray(value.sourceRows))return;selected.value=order;rows.value=value.rows;sourceRows=value.sourceRows;sourcePath=route.path}
function changed(fresh:any){for(const row of sourceRows){if(row.requestNumber || String(row.id)!==String(fresh.id))continue;const normalized=detailRow(row,sourcePath);if(normalized && String(normalized.id)===String(fresh.id))Object.assign(row,fresh)}}
watch(()=>JSON.stringify([route.fullPath,store.getters.token,store.getters.userInfo?.id,store.getters.userInfo?.orgId,store.getters.userInfo?.roleId]),clear,{flush:'sync'})
onMounted(()=>window.addEventListener(orderRowDetailEvent,open))
onBeforeUnmount(()=>{window.removeEventListener(orderRowDetailEvent,open);clear()})

return (_ctx: any,_cache: any) => {
  return (selected.value)
    ? (_openBlock(), _createBlock(_unref(AllOrderDetailWindow), {
        key: 0,
        order: selected.value,
        rows: rows.value,
        onClose: clear,
        onChanged: changed
      }, null, 8, ["order", "rows"]))
    : _createCommentVNode("", true)
}
}

})